<template>
  <div
    style="background-color: rgb(255, 255, 255); border: 1px solid rgb(33, 150, 243); border-radius: 6px 6px 0 0; margin-right: 0px; ">
    <div v-if="false" style="width: 100%; display: flex; align-items: center; padding: 5px 8px 2px 8px;">
      <div class="chip-container">
        <div style="height: 23px; color: gray; font-size: 13px; align-content: center; ">
        {{ $i18n.t("chat.input_bar_ai_action_more") }}
        </div>
        <v-chip color="primary" outlined label v-for="(item, index) in actionTypes"
          :key="index"
          class="ma-1"
          dark
          @click="sendAutoActionPrompt(item.title, item)"
          :style="{ height: '23px', fontSize: '13px', marginLeft: '2px', opacity: noSubscription ? 0.6 : 1, pointerEvents: noSubscription ? 'none' : 'auto'}">
          {{ item.title }}
        </v-chip>
      </div>
    </div>
    <div style="width: 100%; display: flex; justify-content: flex-start; padding: 5px 8px 2px 8px;">
      <!-- 自动识别的快捷菜单 -->
      <div v-if="!hideAutoActionType" style="width: 100%; display: flex; align-items: center;">
        <div style="display: flex; align-items: center;">
          <div style="height: 23px; color: gray; font-size: 13px; align-content: center; ">
            {{ $i18n.t("chat.input_bar_ai_action_title") }}
          </div>
          <v-chip v-if="autoActionTypeFirst != null" color="primary" outlined label
            @click="sendAutoActionPrompt(autoActionTypeFirst.title, autoActionTypeFirst)"
            :style="{ height: '23px', fontSize: '13px', marginLeft: '2px', opacity: noSubscription ? 0.6 : 1, pointerEvents: noSubscription ? 'none' : 'auto'}">
            {{ autoActionTypeFirst.title }}
          </v-chip>
          <v-chip v-if="autoActionTypeSecond != null" color="primary" outlined label
            @click="sendAutoActionPrompt(autoActionTypeSecond.title, autoActionTypeSecond)"
            :style="{ height: '23px', fontSize: '13px', marginLeft: '10px', opacity: noSubscription ? 0.6 : 1, pointerEvents: noSubscription ? 'none' : 'auto'}">
            {{ autoActionTypeSecond.title }}
          </v-chip>
        </div>
        <div style="margin-left: auto; margin-right: 5px; display: flex">
          <!-- <v-btn style="height: 23px; max-width: 30px; font-size: 12px" outlined color="indigo"> 更多指令</v-btn> -->
          <!-- <v-icon @click="previewArtList()" >{{ !isArtListVisible ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon> -->
          <v-icon color="rgb(128, 128, 128)" @click="chageAction">mdi-refresh</v-icon>
        </div>
      </div>
      <!-- 选择的快捷菜单 -->
      <div v-if="hideAutoActionType" style="display: flex;">
        <v-chip v-if="selectedTaskType != null" close color="primary" outlined label @click:close="clearSelectTask"
          style="height: 23px; font-size: 13px; margin-right: 0px; ">
          {{ selectedTaskType.title }}
        </v-chip>
        <div v-if="false" style="display: flex; align-items: center; padding: 0 5px;">
          <SwitchCompoent @change="handleSwitchChange"></SwitchCompoent>
          <div style="font-size: 13px; margin-left: 5px; "> {{ '选模板' }} </div>
        </div>
        <div v-if="showTemplateSelectedBtn || showFileSelectedBtn" style="display: flex;">
          <!-- <v-file-input class="custom-file-input" hide-input truncate-length="15"></v-file-input> -->
          <v-btn v-if="showTemplateSelectedBtn" small style="height: 23px; font-size: 11px; margin-left: 5px; 
            display: flex; align-items: center" color='secondary' :disabled="isSending" @click="showTemplateMenu()">
            {{ selectTemplateBtnTxt }}
            <v-icon size="16" style="margin-top: 2px;"> mdi-chevron-up </v-icon>
          </v-btn>
          <div v-if="showFileSelectedBtn" style="display: flex;">
            <input ref="fileInput" type="file" @change="handleFileChange" style="display: none" />
            <v-btn small style="height: 23px; font-size: 11px; margin-left: 5px;" @click="addFile()"
              :loading="fileUploading" color='blue-grey' class="white--text" :disabled="fileUploading || isSending">
              {{ uploadFileBtnTxt }}
              <v-icon size="16" style="margin-top: 2px;"> mdi-paperclip </v-icon>
            </v-btn>
            <!-- <v-icon right dark> mdi-cloud-upload </v-icon> -->
          </div>
        </div>
        <!-- <v-chip v-if="selectedTaskOptions != null" color="primary" outlined label
          style="height: 23px; font-size: 13px;">
          {{ selectedTaskOptions.title }}
        </v-chip> -->
      </div>
      <!-- <v-chip-group class="mx-1" mandatory active-class="primary--text" style="height: 32px;">
        
      </v-chip-group> -->
      <!-- 建议的操作 -->
      <div v-if="hideAutoActionType">
        <v-chip v-if="selectedTaskType == null" color="primary" outlined label :ripple="false"
          @click="send($i18n.t('chat.input_bar_suggest_action_abstract'))"
          :style="{ height: '23px', fontSize: '13px', marginRight: '10px', opacity: noSubscription ? 0.6 : 1, pointerEvents: noSubscription ? 'none' : 'auto'}">
          {{ $i18n.t("chat.input_bar_suggest_action_abstract") }}
        </v-chip>
        <v-chip v-if="selectedTaskType == null" color="primary" outlined label :ripple="false"
          @click="send($i18n.t('chat.input_bar_suggest_action_summary'))" :style="{ height: '23px', fontSize: '13px', opacity: noSubscription ? 0.6 : 1, pointerEvents: noSubscription ? 'none' : 'auto'}">
          {{ $i18n.t("chat.input_bar_suggest_action_summary") }}
        </v-chip>
      </div>
      <!-- <v-chip-group class="mx-1" mandatory active-class="primary--text" style="height: 32px;">
      </v-chip-group> -->
    </div>
    <!-- 任务菜单 -->
    <MvWdTaskTypeMenu ref="refTaskTypeMenu" @onClickMenu="onClickMenu" @clearInput="clearInput" />
    <!-- 选项菜单 -->
    <MvWdTaskOptionMenuCreateppt ref="refTaskOptionMenuCreateppt" @onClickMenu="onClickCreatePptOptionMenu" />
    <div v-if="false" style="display: flex; justify-content: flex-end; align-items: center; margin-top: -10px; ">
      <!-- 弹窗 -->
      <v-textarea ref="refInputTextArea" v-model="chatInputMessage" :disabled="isSending" :placeholder="placeholder"
        class="pb-4 px-1 msg-input" :maxlength="4000" solo height="88" autofocus rows="2"
        background-color="rgb(255, 255, 255) " @input="onTextInputChanged" @focus="onFocus" @blur="loseFocus"
        @keydown.enter.stop="send(null)" no-resize>
        <!-- style="font-size: 13px; flex: 1;  width: 100%;
          border-radius: 6px;   
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);" -->
        <!-- <template v-slot:append style="height: 60px; display: flex; align-items: flex-end">
          <v-btn v-if="!isSending" icon color="primary" style="width: 22px; height: 22px;"
            type="submit" :disabled="isSending" @click="sendPrompt">
            <v-icon> mdi-send </v-icon>
          </v-btn>
          <v-progress-circular v-if="isSending"  style="width: 22px; height: 22px;" indeterminate color="primary"></v-progress-circular>
          <div v-if="isSending" style="width: 22px; height: 22px;"></div>
        </template> -->
      </v-textarea>
      <!-- 预置问题 -->
      <WdAisaPromptPreMenu ref="refPrePromptsMenu" :propsMenuItems="prePrompts" @selectPrompt="selectPrompt" />

      <!-- <v-btn icon class="mb-4 mr-1" color="primary" v-if="prompstotalCount"
        :disabled="isSending" :loading="isLoadingPrePrompts" @click="onClickShowPrePromptsMenu">
        <v-icon> mdi-notebook-multiple </v-icon>
      </v-btn> -->
      <!-- 发送 -->
      <v-btn v-if="!isSending" style="position: absolute; margin-right: 6px; background-color: #ffffff;" icon
        color="primary" elevation="0" type="submit" :disabled="isSending" @click="send(null)">
        <v-icon> mdi-send </v-icon>
      </v-btn>
      <v-progress-circular v-if="isSending" indeterminate color="primary" style="position: absolute; margin-right: 20px"
        size=25></v-progress-circular>
      <div v-if="isSending" style="width: 25px; position: absolute; margin-right: 16px"></div>
    </div>
    <div class="custom-input-box">
      <!-- inputBox area -->
      <div class="input-area" ref="inputArea">
        <textarea ref="refInputTextArea" v-model="chatInputMessage" @input="onTextInputChanged"
          :placeholder="placeholder" rows="2" :maxlength="4000" auto-grow @focus="onFocus" @blur="loseFocus"
          @keypress="handleKeyDown"></textarea>
      </div>

      <!-- bottom area -->
      <div class="bottom-buttons">
        <!-- bottom-left area -->
        <div class="left-buttons">
          <button v-show="false"
            :class="{ 'action-button-slected': isDeepResoningSelected, 'action-button': !isDeepResoningSelected }"
            @click="deepThink">
            深度推理
          </button>
          <button v-show="false"
            :class="{ 'action-button-slected': isWebSearchSelected, 'action-button': !isWebSearchSelected }"
            @click="searchWeb">
            联网搜索
          </button>
        </div>
        <!-- bottom-right area -->
        <div class="right-buttons">
          <!-- <button class="attachment-button" @click="triggerFileInput">
            <span v-if="files.length > 0">已选择 {{ files.length }} 个文件</span>
            <span v-else>选择附件</span>
          </button> -->
          <button v-if="!isSending" :disabled="isSending || noSubscription" @click="send(null)">
            <v-icon v-if="noSubscription" color="grey"> mdi-send </v-icon>
            <v-icon v-else color="primary"> mdi-send </v-icon>
          </button>
          <v-progress-circular v-if="isSending" indeterminate color="primary" size=25></v-progress-circular>
        </div>
      </div>

      <!-- 隐藏的文件输入 -->
      <!-- <input
        type="file"
        ref="fileInput"
        style="display: none"
        @change="handleFileUpload"
      /> -->
    </div>
    <TemplateSelect ref="refTemplateSelect" v-on:selectedTemplate="saveTemplatte" />
    <FontTypeSelect ref="refFontTypeSelect" />
    <ShapeColorSelect ref="refShapeColorSelect" />
  </div>
</template>

<script>
import store from "@store";
import { get, sync } from "vuex-pathify";
import { i18n } from "@i18n";
import '@/styles/apps/customInputBox.scss';

import { wd_getGptPrePromptList, api_upload_file } from "../../api/apiAisa.js";
// Pubsub
// Pub
import { publish } from "@/service/wd_pubsub.js";
import { aisaPubIds, gptPubIds, actionMenuPubIds } from "@/service/wd_pubsub_config.js";
import { subscribe, unsubscribe } from "@/service/wd_pubsub.js";
import { userKeys, wdConfigData } from "@/service/wd_app_config.js";
import { getCurrentSelectState, getSelectedShapeText, getSelectedFirstSlideText, getAllSlideJsonText, getCurrentSlideJSONData, getCurrentSlidePageIndex } from "@/views/gpt/util/gpt_addin_utils";
// import { wdConfigData } from "@/service/wd_app_config.js";
import WdAisaPromptPreMenu from "../suggest-question/question-menu.vue";
import MvWdTaskTypeMenu from "@/views/gpt/widgets/action/mv-wd-task-type-menu.vue";
import MvWdTaskOptionMenuCreateppt from "@/views/gpt/widgets/action/mv-wd-task-option-menu-createppt.vue";
import TemplateSelect from "../dialog/template-select.vue";
import FontTypeSelect from "../dialog/fontTypeSelect.vue";
import ShapeColorSelect from "../dialog/shapeColorSelect.vue";
import SwitchCompoent from "../dialog/switchComponent.vue";
import aiMenusZh from "@/store/modules/aiMenus-zh";
import aiMenusEn from "@/store/modules/aiMenus-en";
export default {
  components: {
    WdAisaPromptPreMenu,
    MvWdTaskTypeMenu,
    MvWdTaskOptionMenuCreateppt,
    TemplateSelect,
    FontTypeSelect,
    ShapeColorSelect,
    SwitchCompoent
  },
  props: {
    isSend: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isArtListVisible: false,
      hideAutoType: true,
      showQuickAsk: true,
      isSending: false,
      chatInputMessage: "",
      waitingText: "",
      prompstotalCount: false,
      showTemplateSelectedBtn:false,
      showFileSelectedBtn:false,
      // 预置问题
      isLoadingPrePrompts: false,
      showMenuAtElement: null,
      prePrompts: [],
      placeholder: i18n.t("chat.default_input_placeholder"),
      
      inputBoxMaxRows: 10,
      inputBoxLineHeight: 24,
      isDeepResoningSelected: false,
      isWebSearchSelected: false,

      currentSelectedContent: "",

      currentFileName:"",

      selectedFile: null,
      selectFileId:null,
      fileUploading: false,
      uploadFileBtnTxt: i18n.t('ppt_add_in_main.btn_select_file'),
      uploadedFile:false,
      selectTemplateBtnTxt:i18n.t('ppt_add_in_main.btn_select_template_default'),
      actionTypes: [],

      showTemplateSelectSwitchBtn: false,
      selectTemplateSwitch:false,
    };
  },
  computed: {
    ...get("gpt", ["autoActionTypeFirst", "autoActionTypeSecond", "hideAutoActionType", "selectedTaskType", "selectedTaskOptions", 'noSubscription']),
    ...sync("gpt", ["autoActionTypeFirst", "autoActionTypeSecond", "hideAutoActionType", "selectedTaskType", "selectedTaskOptions", 'noSubscription']),
  },
  watch: {
    selectedTaskType(newValue) {
      store.set('gpt/currentSelectedTemplateName', null)
      store.set('gpt/currentPreviewSlideId', null)
      store.set('gpt/currentSelectedSemanticTemplateWhole', null)
      localStorage.setItem(userKeys.key_user_settings_select_template_is_semantic, JSON.stringify(false))
      this.selectTemplateBtnTxt = i18n.t('ppt_add_in_main.btn_select_template_default')
      
      if (newValue) {
        if (newValue.id === 'task_one_page_general') {
          this.placeholder = i18n.t("chat.onepage_slide_input_placeholder")
          this.showTemplateSelectedBtn = true
          this.showFileSelectedBtn = true
          this.showTemplateSelectSwitchBtn = false
        } else if(newValue.id === 'taskType_semantic_whole_template_ppt') {
          this.placeholder = i18n.t("chat.create_slide_input_placeholder")
          this.showTemplateSelectedBtn = true
          this.showFileSelectedBtn = true
        } else if(newValue.id === 'task_all_normal' || newValue.id === 'task_bp_normal' || newValue.id === 'task_bp_tan_methodology' || newValue.id === 'taskType_outline') {
          this.placeholder = i18n.t("chat.create_slide_input_placeholder")
          this.showTemplateSelectedBtn = false
          this.showFileSelectedBtn = false
          this.showTemplateSelectSwitchBtn = false
        } else if(newValue.id === 'taskType_ppt_from_file') {
          this.showTemplateSelectedBtn = this.selectTemplateSwitch
          this.showFileSelectedBtn = false
          this.showTemplateSelectSwitchBtn = true
          this.placeholder = i18n.t("chat.default_input_placeholder")
        } else {
          this.placeholder = i18n.t("chat.default_input_placeholder")
          this.showTemplateSelectedBtn = false
          this.showFileSelectedBtn = false
          this.showTemplateSelectSwitchBtn = false
        }
      } else {
        this.placeholder = i18n.t("chat.default_input_placeholder")
        this.showTemplateSelectedBtn = false
        this.showFileSelectedBtn = false
        this.showTemplateSelectSwitchBtn = false
      }
    }
  },
  methods: {
    // resoning
    deepThink() {
      console.log('deep resoning');
      this.isDeepResoningSelected = !this.isDeepResoningSelected
    },
    // web search
    searchWeb() {
      console.log('web search');
      this.isWebSearchSelected = !this.isWebSearchSelected
    },
    handleSwitchChange(status) {
      this.selectTemplateSwitch = status
      this.showTemplateSelectedBtn = this.selectTemplateSwitch
      this.showFileSelectedBtn = false
    },
    handleKeyDown(event) {
      if (event.key === 'Enter') {
        if (event.shiftKey) {
          // Shift + Enter：new line
        } else {
          event.preventDefault();
          if (!this.noSubscription) {
            this.send(null)
          } else {
            this.$message.warning(i18n.t("home.license_error_description_901"))
          }
        }
      }
    },
    addFile() {
      this.$refs.fileInput.click()
    },
    handleFileChange(e) {
      const file = e.target.files[0]
      if (file) {
        this.fileUploading = true
        this.selectedFile = file
        this.uploadedFile = true
        // console.log('已选择文件:', this.selectedFile.name)
        this.setUploadFileBtnTxt(this.selectedFile.name.substring(0,4) + '...')
        // this.setUploadFileBtnTxt(this.selectedFile.name.substring(0,4) + '...' + this.selectedFile.name.substring(this.selectedFile.name.length - 5,this.selectedFile.name.length))
        this.upLoadFile()
      } else {
        this.fileUploading = false
        this.selectedFile = null
        this.setUploadFileBtnTxt(null)
      }
    },
    saveTemplatte(txt) {
      this.selectTemplateBtnTxt = txt
    },
    upLoadFile() {
      publish(
        aisaPubIds.pubId_Action_Menu_PPT_From_File_Upload, 
        { 
          loadinText: i18n.t("ppt_add_in_main.input_bar_placeholder_uploading_first") 
          + this.selectedFile.name +
          i18n.t("ppt_add_in_main.input_bar_placeholder_uploading_second") 
        }
      );
      var formData = new FormData();
      formData.append("attachmentFile", this.selectedFile);
      api_upload_file(formData).then(
        (response) => {
          publish(
            aisaPubIds.pubId_Action_Menu_PPT_From_File_Finish, 
            { 
              loadinText: i18n.t("ppt_add_in_main.input_bar_placeholder_after_upload_file_first") 
              + this.selectedFile.name +
              i18n.t("ppt_add_in_main.input_bar_placeholder_after_upload_file_second"), fileName: this.selectedFile.name 
            }
          );
          this.fileUploading = false
          if (response.data.Code == 0) {
            this.selectFileId = response.data.Result.FileMD5
            this.$emit('getFileId', this.selectFileId)
          } else {
            publish(aisaPubIds.pubId_Action_Menu_PPT_From_File_Finish, {});
            this.$message.warning(response.data.Description)
            this.selectedFile = null
            this.setUploadFileBtnTxt(null)
          }
        },
        (error) => {
          this.fileUploading = false
          this.selectedFile = null
          this.setUploadFileBtnTxt(null)
          publish(aisaPubIds.pubId_Action_Menu_PPT_From_File_Finish, {});
          this.$message.warning(error)
          console.error(error);
        }
      );
    },
    setUploadFileBtnTxt(btnText) {
      if (btnText) {
        this.uploadFileBtnTxt = btnText
      } else {
        this.uploadFileBtnTxt = i18n.t('ppt_add_in_main.btn_select_file')
      }
    },
    clearSelectTask() {
      store.set("gpt/selectedTaskType", null);
      store.set("gpt/selectedTaskOptions", null);
      this.placeholder = i18n.t("chat.default_input_placeholder");
      publish(actionMenuPubIds.pubId_Action_Menu_clear_action, {})
      this.placeholder = i18n.t("chat.default_input_placeholder")
      this.showTemplateSelectedBtn = false
      this.showFileSelectedBtn = false
      this.showTemplateSelectSwitchBtn = false
      this.selectedFile = null
      this.setUploadFileBtnTxt(null)
      this.$emit('getFileId', null)
    },
    clearState() {
      store.set("gpt/hideAutoActionType", true);
      store.set("gpt/autoActionTypeFirst", null);
      store.set("gpt/autoActionTypeFirst", null);
      store.set("gpt/autoActionType", null)
    },
    calculateInputHeight(){
      const textarea = this.$refs.refInputTextArea;
      textarea.style.height = 'auto';
      const newHeight = Math.min(textarea.scrollHeight, this.inputBoxMaxRows * this.inputBoxLineHeight);
      textarea.style.height = `${newHeight}px`;
      if (textarea.scrollHeight > this.inputBoxMaxRows * this.inputBoxLineHeight) {
        textarea.style.overflowY = 'auto';
      } else {
        textarea.style.overflowY = 'hidden';
      }
    },
    resetInputHeight() {
      const textarea = this.$refs.refInputTextArea;
      const newHeight = Math.min(textarea.scrollHeight, 2 * this.inputBoxLineHeight);
      textarea.style.height = `${newHeight}px`;
    },
    onTextInputChanged() {
      this.calculateInputHeight()
      if (this.chatInputMessage === "/") {
        this.$refs.refTaskTypeMenu.funcShowMenu(this.$refs.inputArea);
      } else {
        this.$refs.refTaskTypeMenu.funcHideMenu();
      }
      if(this.chatInputMessage.length >= 4000) {
        this.$message.warning(i18n.t("ppt_add_in_main.input_word_count_limit"))
      }
    },
    onFocus() {
      if (this.selectedTaskType || this.selectedTaskOptions) {
        return
      }
      // getAllSlideJsonText((allSlideData) => {
      //   console.log('allSlideData: ' + allSlideData);
      //   return
      // }, (error) => {
      //   this.$message.warning(error)
      // })
      // getCurrentSlideJSONData((currentSelectedSlideJSONData) => {
      //   if (currentSelectedSlideJSONData.length > 0) {
      //     console.log('CurrentSlideJSONData: ', JSON.stringify(currentSelectedSlideJSONData));
      //   } else {
      //     this.$message.warning(i18n.t("home.content_empty"))
      //   }
      // })
      getCurrentSelectState((currentState) => {
        store.set("gpt/hideAutoActionType", false);
        let slideState = currentState.selectSlide.state
        let shapeState = currentState.selectShape.state        
        if (slideState == i18n.t("ppt_select_state.select_one_slide")) {
          switch (shapeState) {
            case i18n.t("ppt_select_state.select_no_shape"):
              store.set("gpt/autoActionTypeFirst", this.actionTypes[8]);
              store.set("gpt/autoActionTypeSecond", this.actionTypes[3]);
              if(currentState.selectShape.shapeType.find(item => item == "Image") != null && currentState.selectShape.shapeType.find(item => item == "Text") == null) {
                store.set("gpt/autoActionTypeSecond", this.actionTypes[4]);
              }
              break;
            case i18n.t("ppt_select_state.select_one_shape"):
              store.set("gpt/autoActionTypeFirst", this.actionTypes[0]);
              store.set("gpt/autoActionTypeSecond", this.actionTypes[2]);
              if(currentState.selectShape.shapeType.find(item => item == "Image") != null && currentState.selectShape.shapeType.find(item => item == "Text") == null) {
                store.set("gpt/autoActionTypeFirst", this.actionTypes[4]);
                store.set("gpt/autoActionTypeSecond", this.actionTypes[6]);
              }
              break;
            case i18n.t("ppt_select_state.select_mluti_shapes"):
              store.set("gpt/autoActionTypeFirst", this.actionTypes[0]);
              store.set("gpt/autoActionTypeSecond", this.actionTypes[1]);
              if(currentState.selectShape.shapeType.find(item => item == "Image") != null) {
                if (currentState.selectShape.shapeType.find(item => item == "Text") == null) {
                  store.set("gpt/autoActionTypeSecond", this.actionTypes[4]);
                } else {
                  if (currentState.selectShape.shapeType.filter(item => item === "Text").length  == 1) {
                    store.set("gpt/autoActionTypeSecond", this.actionTypes[2]);
                  }
                }
              }  
              break;
            default:
              break;
          }
        } else {
          this.clearState()
        }
      })

      getSelectedShapeText((selectContent) => {
        this.currentSelectedContent = selectContent
        store.set("gpt/currentSelectContent", selectContent);
      })

      getCurrentSlidePageIndex((currentSelectedSlideIndex) => {
          if (currentSelectedSlideIndex != null) {
            store.set("gpt/currentSelectSlidePageIndex", currentSelectedSlideIndex)
          } else {
            this.$message.warning(i18n.t("home.content_empty"))
          }
        })
    },
    loseFocus() {
      // if (this.selectedTaskType || this.selectedTaskOptions) {
      //   return
      // }
      // store.set("gpt/hideAutoActionType", true);
    },
    handleSend(text, content, warningKey, menu) {
      if (content && content !== "") {
        this.currentSelectedContent = content;
        store.set("gpt/currentSelectContent", content);
        store.set("gpt/autoActionType", menu);
        this.send(text);
      } else {
        this.$message.warning(this.$t(warningKey));
      }
    },
    sendAutoActionPrompt(text, menu) {
      if (this.isSending) {
        this.$message.warning(i18n.t("home.generating_sending_remind_message"))
        return
      }
      switch (true) {
        case (
          menu.id === "task_generate_image" ||
          menu.id === "task_change_image" ||
          menu.id === "task_generate_image_replace" ||
          menu.id === "taskType_create_title" ||
          menu.id === "taskType_one_page_content_from_title"
        ):
          getSelectedFirstSlideText((currentSelectedSlideContent) => {
            this.handleSend(text, currentSelectedSlideContent, "home.content_empty", menu);
          });
          break;

        case menu.id === "task_enrich_one_page_content":
          getCurrentSlideJSONData((currentSelectedSlideJSONData) => {
            const content = currentSelectedSlideJSONData.length > 0
              ? JSON.stringify(currentSelectedSlideJSONData)
              : "";
            this.handleSend(text, content, "home.content_empty", menu);
          });
          break;

        default:
          getSelectedShapeText((selectContent) => {
            this.handleSend(text, selectContent, "home.text_content_empty_unsupport_shape_type", menu);
          });
          break;
      }
    },
    send(text) {
      if (this.isSending) {
        this.$message.warning(i18n.t("home.generating_sending_remind_message"))
        return
      }
      if (text != null) {
        // this.showQuickAsk = false
        this.isSending = true
        this.resetInputHeight()
        this.$emit("sendMsg", text)
        return
      }

      if (this.chatInputMessage.trim() == "") {
        /** there are some types no need input text */
        if (this.selectedTaskType) {
          if (this.selectedTaskType.id === 'taskType_ppt_from_file') {
            if (this.selectFileId) {
              this.isSending = true;
              this.resetInputHeight()
              const userMsg = i18n.t("ppt_add_in_main.input_bar_placeholder_upload_file_first")
                + this.currentFileName +
                i18n.t("ppt_add_in_main.input_bar_placeholder_upload_file_second");
              this.$emit("sendMsg", userMsg);
            } else {
              this.$message.warning(i18n.t("ppt_add_in_main.msg_pls_select_file"))
            }
            return
          } else if (this.selectedTaskType.id === 'taskType_semantic_whole_template_ppt') {
            if (JSON.parse(localStorage.getItem(userKeys.key_user_settings_select_template_is_semantic_whole))) {
              if (this.selectFileId) {
                // template & file
                this.isSending = true;
                this.resetInputHeight()
                const userMsg = i18n.t("ppt_add_in_main.input_bar_placeholder_upload_file_first")
                    + this.currentFileName +
                    i18n.t("ppt_add_in_main.input_bar_placeholder_upload_file_second");
                this.$emit("sendSWTempleMsg", userMsg);
              } else {
                // template but no file
                this.$message.warning(i18n.t("ppt_add_in_main.msg_pls_select_file"))
              }
            } else {
              // no template
              this.$message.warning(i18n.t("ppt_add_in_main.msg_pls_select_template"))
            }
            return
          } else if (this.selectedTaskType.id === 'task_ppt_translate_all_en' || this.selectedTaskType.id === 'task_ppt_translate_all_zh') {
            this.isSending = true
            this.resetInputHeight()
            getAllSlideJsonText((allSlideData) => {
              store.set("gpt/allSlidesJSONContent", allSlideData);
              this.$emit("sendMsg", this.selectedTaskType.title)
              return
            }, (error) => {
              this.isSending = false
              this.$message.warning(error)
            })
          } else {
            this.$message.warning(i18n.t("dialog.input_content_not_null"));
            const e = window.event || arguments[0];
            if (e.key === "Enter" || e.code === "Enter" || e.keyCode === 13) {
              e.returnValue = false;
              return false;
            }
          }
        } else {
            this.$message.warning(i18n.t("dialog.input_content_not_null"));
            const e = window.event || arguments[0];
            if (e.key === "Enter" || e.code === "Enter" || e.keyCode === 13) {
              e.returnValue = false;
              return false;
            }
        }
      } else if (this.chatInputMessage.length > 2000) {
        this.$message.warning(i18n.t("ppt_add_in_main.input_word_count_limit"));
      } else {
        this.isSending = true;
        this.resetInputHeight()
        // this.waitingText = i18n.t("aisa.text_gpt_optimize");
        if (this.selectedTaskType && this.selectedTaskType.id === 'taskType_semantic_whole_template_ppt' && JSON.parse(localStorage.getItem(userKeys.key_user_settings_select_template_is_semantic_whole))) {
          this.$emit("sendSWTempleMsg", this.chatInputMessage);
        } else { 
          this.$emit("sendMsg", this.chatInputMessage);
        }

        this.chatInputMessage = "";
        // setTimeout(() => {
        //   this.waitingText = i18n.t("aisa.text_gpt_generating");
        // }, 1500);
      }
    },
    onClickShowPrePromptsMenu(e) {
      this.showMenuAtElement = e;
      if (this.prePrompts.length == 0) {
        this.getGptPrePrompts();
      } else {
        this.$refs.refPrePromptsMenu.funcShowMenu(this.showMenuAtElement);
      }
    },
    onClickMenu(menu) {
      this.clearSelectTask()
      this.clearState()
      if (menu.id === 'task_operation_font_type') {
        this.$refs.refFontTypeSelect.clickShowDialog()
      } else if (menu.id === 'task_operation_shape_color') {
        this.$refs.refShapeColorSelect.clickShowDialog()
      } else {
        store.set("gpt/selectedTaskType", menu);
        if (menu.id == "task_bp_tan_methodology" || menu.id == "task_bp_normal" || menu.id == "task_all_normal") {
          store.set("gpt/selectedTaskOptions", {
            id: "ppt_option_menu_textonly",
            title: "纯文字",
          });
        }
        else if (menu.id == "task_expand_silde_content" || menu.id == "task_extract_slide_content") {
          this.chatInputMessage = "";
          // this.excuteCopilot();
        }
      }
    },
    // 创建PPT选项菜单
    onClickCreatePptOptionMenu(menu) {
      this.clearState()
      store.set("gpt/selectedTaskOptions", menu);
    },
    showTemplateMenu() {
      this.$refs.refTemplateSelect.clickShowDialog()
    },
    clearInput() {
      this.chatInputMessage = "";
      this.$nextTick(() => {
        this.$refs.refInputTextArea.focus();
      });
    },
    //判断是否存在预置问题
    getGptPrePromptsCount() {
      var params = {
        configId: localStorage.getItem("WindowId"),
      };
      wd_getGptPrePromptList(params).then(
        (response) => {
          if (response.data.Code == 0) {
            if (response.data.Result.TotalCount != "0") {
              this.prompstotalCount = true;
            } else {
              this.prompstotalCount = false;
            }
          } else {
            this.$message.error(response.data.Description);
          }
        },
        (err) => {
          console.error(err);
        }
      );
    },
    getGptPrePrompts() {
      var params = {
        configId: localStorage.getItem("WindowId"),
      };
      var that = this;
      this.isLoadingPrePrompts = true;
      wd_getGptPrePromptList(params).then(
        (response) => {
          that.handleGetGptPrePromptList(response);
        },
        (err) => {
          console.error(err);
        }
      );
    },
    handleGetGptPrePromptList(response) {
      if (response.data.Code == 0) {
        if (response.data.Result.TotalCount != "0") {
          this.prompstotalCount = true;
        } else {
          this.prompstotalCount = false;
        }
        this.isLoadingPrePrompts = false;
        this.prePrompts = response.data.Result.ListData;
        this.$refs.refPrePromptsMenu.funcShowMenu(this.showMenuAtElement);
      } else {
        this.$message.error(response.data.Description);
      }
    },
    selectPrompt(text) {
      this.chatInputMessage = text;
      this.$refs.refInputTextArea.focus();
    },
    gettextlist(text) {
      this.chatInputMessage = "";
      this.chatInputMessage = text;
      this.$refs.refInputTextArea.focus();
    },
    // Pubsub
    pubCallback(msgName, data) {
      if (msgName == aisaPubIds.pubId_Local_Aisa_AskGpt_Generating) {
        this.isSending = true
      } else if (msgName == aisaPubIds.pubId_Action_Menu_PPT_From_File_Upload) {
        this.placeholder = data.loadinText
        if(this.selectedTaskType.id !== 'taskType_semantic_whole_template_ppt') {
          this.isSending = true;
        }
      } else if (msgName == aisaPubIds.pubId_Action_Menu_PPT_From_File_Finish) {
        this.isSending = false;
        if (data) {
          this.placeholder = data.loadinText
          this.currentFileName = data.fileName
          this.selectFileId = data.selectFileId
        } else {
          this.selectFileId = null
          this.placeholder = i18n.t("chat.default_input_placeholder");
        }
      } else if (msgName == actionMenuPubIds.pubId_Action_Menu_Change_OnePage_Template) {
        this.isSending = true;
        this.$emit("sendMsg", i18n.t("chat.text_prompt_change_template_regenerate"));
      } else if(msgName == actionMenuPubIds.pubId_Action_Menu_Click_Change_OnePage_Template) {
        this.showTemplateMenu()
      } else {
        if (msgName == aisaPubIds.pubId_Local_Aisa_AskGpt_Success || msgName == gptPubIds.pubId_Local_Aisa_AskGpt_Success) {
          this.waitingText = "";
        } else if (msgName == gptPubIds.pubId_Local_PPT_init_error) {
          this.$message.warning(i18n.t("home.text_general_warring_ppt_init_error"))
        } else if (msgName == gptPubIds.pubId_Local_PPT_image_generate_error) {
          this.$message.error(i18n.t("dialog.error_message"))
        }
        this.isSending = false;
        this.waitingText = "";
        this.clearSelectTask()
        this.clearState()
        // avoid onFocus error infinite loop
        if (msgName != gptPubIds.pubId_Local_PPT_init_error) {
          this.onFocus()
        }
      }
      // else{
      //   this.$message.error(this.$t('main.title_tryagin'))
      //   this.isSending = false;
      //   this.waitingText = "";
      // }
    },
    previewArtList(){
      this.isArtListVisible = !this.isArtListVisible 
    },
    chageAction() {
      getCurrentSelectState((currentState) => {
        store.set("gpt/hideAutoActionType", false);
        let slideState = currentState.selectSlide.state
        let shapeState = currentState.selectShape.state
        if (slideState == i18n.t("ppt_select_state.select_one_slide")) {
          switch (shapeState) {
            case i18n.t("ppt_select_state.select_no_shape"):{
              const numbers_no_shape = [0, 3, 4, 7, 8];
              this.setRandomAutoActionType(numbers_no_shape)
              break;
            }
            case i18n.t("ppt_select_state.select_one_shape"):{
              const numbers_one_shape = [0, 2, 4, 5, 7, 8];
              this.setRandomAutoActionType(numbers_one_shape)
              break;
            }
            case i18n.t("ppt_select_state.select_mluti_shapes"):{
              if (currentState.selectShape.shapeType.filter(item => item === "Text").length == 0) {
                const numbers = [0, 3, 4, 7, 8];
                this.setRandomAutoActionType(numbers)
              } else if (currentState.selectShape.shapeType.filter(item => item === "Text").length == 1) {
                const numbers = [0, 2, 3, 4, 5, 7, 8];
                this.setRandomAutoActionType(numbers)
              } else {
                let numbers = []
                if (currentState.selectShape.shapeType.find(item => item == "Image") == null) {
                  numbers = [0, 1, 3, 4, 7, 8];
                } else {
                  numbers = [0, 1, 2, 3, 4, 5, 7, 8];
                }
                this.setRandomAutoActionType(numbers)
              }
              break;
            }
            default:
              break;
          }
        } else {
          this.clearState()
        }
      })
    },
    setRandomAutoActionType(indexArr) {
      // 随机一个作为第一个action
      let firtIndex = indexArr[Math.floor(Math.random() * indexArr.length)]
      store.set("gpt/autoActionTypeFirst", this.actionTypes[firtIndex]);

      const newNumbers = indexArr.filter(item => item !== firtIndex)
      // 去掉之前显示的第一个action，剩余的再随机选一个作为第二个action
      let secondeIndex = newNumbers[Math.floor(Math.random() * newNumbers.length)]
      store.set("gpt/autoActionTypeSecond", this.actionTypes[secondeIndex]);
    }
  },
  //生命周期-创建完成(可以访问当前this实例)
  created() {
    // this.getGptPrePromptsCount();
    i18n.locale = wdConfigData.localLanguage
    this.placeholder = i18n.t("chat.default_input_placeholder")
  },
  //生命周期-挂载完成(可以访问DOM元素)
  mounted() {
    i18n.locale = wdConfigData.localLanguage
    i18n.locale = wdConfigData.localLanguage
    if (i18n.locale == "zhHans") {
      this.actionTypes = aiMenusZh.state.actionTypes
    } else {
      this.actionTypes = aiMenusEn.state.actionTypes
    }
    subscribe(aisaPubIds.pubId_Local_Aisa_AskGpt_Success, this.pubCallback);
    subscribe(aisaPubIds.pubId_Local_Aisa_AskGpt_Generating, this.pubCallback);
    subscribe(gptPubIds.pubId_Local_Aisa_AskGpt_Success, this.pubCallback);
    subscribe(gptPubIds.pubId_Local_PPT_init_error, this.pubCallback);
    subscribe(gptPubIds.pubId_Local_PPT_image_generate_error, this.pubCallback);
    subscribe(aisaPubIds.pubId_Action_Menu_PPT_From_File_Upload, this.pubCallback);
    subscribe(aisaPubIds.pubId_Action_Menu_PPT_From_File_Finish, this.pubCallback);
    subscribe(actionMenuPubIds.pubId_Action_Menu_Change_OnePage_Template, this.pubCallback);
    subscribe(actionMenuPubIds.pubId_Action_Menu_Click_Change_OnePage_Template, this.pubCallback);
  },
  deactivated() {
    this.prompstotalCount = false;
  },
  destroyed() {
    unsubscribe(this.pubCallback);
  }, //生命周期-销毁完成
  activated() { }, //如果页面有keep-alive,这函数会触发
};
</script>

<style lang="scss" scoped>
.generatebtn {
  height: 24px;
  line-height: 24px;
  width: auto;
  /* border:1px solid #cecece; */
  background-color: rgb(233, 236, 246);
  color: grey;
  font-size: 13px;
  padding: 0 5px;
  display: flex;
  align-items: center;
  /* 垂直居中 */
  justify-content: center;
  /* 水平居中 */
  border-radius: 6px;
  border: 1px solid rgb(163, 183, 237);
  cursor: pointer;
  /* 鼠标悬停样式 */
  transition: all 0.3s ease;

  /* 过渡效果 */
  /* 悬停效果 */
  &:hover {
    border-color: #333;
    /* 悬停时边框颜色 */
    background-color: #ffffff;
    /* 悬停时背景颜色 */
  }
}

.msg-input {
  .v-counter {
    margin-top: 2px;
  }
}

.v-input__slot {
  background-color: rgb(240, 240, 240) !important;
}
</style>
<style scoped>
.v-textarea textarea {
  line-height: 2.5rem;
}

.v-text-field {
  margin-top: 13px !important;
}
</style>
<style scoped>
.v-application .pb-4 {
  padding-bottom: 5px !important;
}
</style>